import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import {
  FormInput,
  FormDropDownListById,
  FormCheckbox,
} from "../../forms/form-components";
import {
  getWidgetFontColors,
  fontSizes,
  decimalPlaces,
  thousandSeparators,
  widgetPageSizes,
} from "./utils";
import { List } from "../../components/list";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

export const GridWidgetSettings = (props) => {
  const currentTheme = useSelector((state) => state.currentTheme);
  const fontColors = getWidgetFontColors(currentTheme);
  const { pageState, formState, onFieldValueChange, ...other } = props;

  let dataSourceTitle = formState.formValues.settings.dataSourceTitle;
  if (!dataSourceTitle) {
    //the report is in view mode
    let dataSource = formState.dataSources.find(
      (e) => e.Id == formState.formValues.dataSourceId
    );
    if (!dataSource.IsImplicit) dataSourceTitle = dataSource.Title;
    else dataSourceTitle = formState.formValues.settings.schema[0].Title;
  }

  const listItemRenderer = (currentTheme) => (props, item, index) => {
    const onFieldCheck = props.onFieldCheck;

    return (
      <div key={item.id} className={`list-item`}>
        <div style={{ width: 28 }}>
          <Checkbox
            disabled={item.isGrouped == true}
            value={item.isVisible}
            onChange={(e) => onFieldCheck(item)}
          />
        </div>
        <div className="list-item-title">{item.title}</div>
      </div>
    );
  };
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="grid-settings">
        <div className="widget-settings-form-group" style={{ marginBottom: 0 }}>
          <div className="header">{t("extras.widget")}</div>
          <div className="content">
            {formState.mode == 2 && (
              <div
                className="row"
                style={{ alignItems: "center", justifyContent: "flex-start" }}
              >
                <div style={{ fontWeight: 600 }}> {t("extras.datasource")}</div>
                <div style={{ marginLeft: 16 }}>{dataSourceTitle}</div>
              </div>
            )}
            <div
              className="row"
              style={{ alignItems: "flex-end", justifyContent: "flex-start" }}
            >
              <div style={{ width: 125 }}>
                <Field
                  id={"settings.maximumRows"}
                  name={"settings.maximumRows"}
                  label={t("extras.maxRows")}
                  type={"number"}
                  component={FormInput}
                  maxLength={7}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    let value = parseFloat(e.target.value);

                    if (isNaN(value)) value = e.target.value;

                    onFieldValueChange({ id: "maximumRows", value: value });
                  }}
                />
              </div>
              <div style={{ marginLeft: 24, width: 125 }}>
                <Field
                  id={"settings.reorderable"}
                  name={"settings.reorderable"}
                  label={t("extras.draggable")}
                  component={FormCheckbox}
                  onChange={(e) =>
                    onFieldValueChange({ id: "reorderable", value: e.value })
                  }
                />
              </div>
              <div style={{ marginLeft: 24, width: 125 }}>
                <Field
                  id={"settings.resizable"}
                  name={"settings.resizable"}
                  label={t("extras.resizable")}
                  component={FormCheckbox}
                  onChange={(e) =>
                    onFieldValueChange({ id: "resizable", value: e.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="widget-settings-form-group" style={{ marginBottom: 6 }}>
          <div className="header">{t("extras.title")}</div>
          <div className="content">
            <div className="row">
              <Field
                id={"settings.title"}
                name={"settings.title"}
                component={FormInput}
                maxLength={255}
                style={{ width: "100%" }}
                onChange={(e) =>
                  onFieldValueChange({ id: "title", value: e.target.value })
                }
              />
            </div>
            <div className="row">
              <div style={{ width: 125 }}>
                <Field
                  id={"settings.titleFontColor"}
                  name={"settings.titleFontColor"}
                  label={t("extras.color*")}
                  component={FormDropDownListById}
                  data={fontColors}
                  dataItemKey="id"
                  textField="title"
                  onChange={(e) =>
                    onFieldValueChange({ id: "titleFontColor", value: e.value })
                  }
                  // disabled={pageState.formValues.IsSystem}
                />
              </div>
              <div style={{ width: 125, marginLeft: 24 }}>
                <Field
                  id={"settings.titleFontSize"}
                  name={"settings.titleFontSize"}
                  label={t("extras.size")}
                  component={FormDropDownListById}
                  data={fontSizes}
                  dataItemKey="id"
                  textField="title"
                  style={{ marginTop: 2 }}
                  onChange={(e) =>
                    onFieldValueChange({ id: "titleFontSize", value: e.value })
                  }
                  // disabled={pageState.formValues.IsSystem}
                />
              </div>
              <div style={{ display: "flex", flex: 1 }}>
                <div style={{ marginLeft: 24 }}>
                  <Field
                    id={"settings.titleFontIsBold"}
                    name={"settings.titleFontIsBold"}
                    label={t("extras.bold")}
                    component={FormCheckbox}
                    onChange={(e) =>
                      onFieldValueChange({
                        id: "titleFontIsBold",
                        value: e.value,
                      })
                    }
                  />
                </div>
                <div style={{ marginLeft: 24 }}>
                  <Field
                    id={"settings.titleFontIsUnderline"}
                    name={"settings.titleFontIsUnderline"}
                    label={t("extras.underline")}
                    component={FormCheckbox}
                    onChange={(e) =>
                      onFieldValueChange({
                        id: "titleFontIsUnderline",
                        value: e.value,
                      })
                    }
                  />
                </div>
                <div style={{ marginLeft: 24 }}>
                  <Field
                    id={"settings.titleFontIsItalic"}
                    name={"settings.titleFontIsItalic"}
                    label={t("extras.italic")}
                    component={FormCheckbox}
                    onChange={(e) =>
                      onFieldValueChange({
                        id: "titleFontIsItalic",
                        value: e.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="widget-settings-form-group" style={{ marginBottom: 0 }}>
          <div className="header">{t("extras.grid")}</div>
          <div className="content">
            <div className="row" style={{ justifyContent: "flex-start" }}>
              <div style={{ width: 125 }}>
                <Field
                  id={"settings.pageSize"}
                  name={"settings.pageSize"}
                  label={t("extras.pagesize")}
                  component={FormDropDownListById}
                  data={widgetPageSizes}
                  dataItemKey="id"
                  textField="title"
                  onChange={(e) =>
                    onFieldValueChange({ id: "pageSize", value: e.value })
                  }
                />
              </div>
              <div style={{ width: 125, marginLeft: 24 }}>
                <Field
                  id={"settings.groupable"}
                  name={"settings.groupable"}
                  label={t("extras.groupable")}
                  component={FormCheckbox}
                  onChange={(e) =>
                    onFieldValueChange({ id: "groupable", value: e.value })
                  }
                />
              </div>
              <div style={{ marginLeft: 24, width: 125 }}>
                <Field
                  id={"settings.filterable"}
                  name={"settings.filterable"}
                  label={t("extras.filterable")}
                  component={FormCheckbox}
                  onChange={(e) =>
                    onFieldValueChange({ id: "filterable", value: e.value })
                  }
                />
              </div>
            </div>
            {formState.formValues.settings.fields &&
              formState.formValues.settings.fields.length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ marginBottom: 6 }}>
                    {" "}
                    {t("extras.visible/hidden")}
                  </div>
                  <List
                    className="grid-fields"
                    items={formState.formValues.settings.fields}
                    itemRenderer={listItemRenderer(currentTheme)}
                    onFieldCheck={(field) => {
                      let fields = formState.formValues.settings.fields;
                      let checked = !field.isVisible;
                      onFieldValueChange({
                        id: "fields",
                        value: fields.map((e) => {
                          if (e.id == field.id)
                            return { ...e, isVisible: checked };
                          else return e;
                        }),
                      });
                    }}
                  />
                </div>
              )}
          </div>
        </div>
      </div>
      <style>
        {`
                    .widget-settings-form-group:nth-child(2) .k-form-field:first-of-type
                    {
                        width: 100%;
                    }
                    
                    .grid-settings
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .grid-settings .k-dropdownlist
                    {
                        border-color: ${currentTheme.componentBorderColor};        
                        box-shadow: none !important;               
                    } 

                    .grid-settings .list-root
                    {
                        display: flex !important;
                        flex-wrap: wrap;
                    }

                    .grid-settings .list-root .list-item
                    {
                        display: flex !important;
                        width: 50%;
                        overflow-x: hidden;
                    }
                    `}
      </style>
    </Fragment>
  );
};
